import { render, staticRenderFns } from "./CardTotalStop.vue?vue&type=template&id=d6a965c2&scoped=true&"
import script from "./CardTotalStop.vue?vue&type=script&lang=js&"
export * from "./CardTotalStop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a965c2",
  null
  
)

export default component.exports